var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (state, undefined, view) {
jade_mixins["heroOption"] = jade_interp = function(hero){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var heroOriginal = hero.original
var selectedState
if ( state.get('selectedHeroOriginal') === heroOriginal)
{
selectedState = 'selected'
}
else if ( view.options.showCurrentHero && state.get('currentHeroOriginal') === heroOriginal)
{
selectedState = 'current'
}
else
{
selectedState = ''
}
buf.push("<div" + (jade.attr("data-hero-original", heroOriginal, true, true)) + (jade.cls(['hero-option',selectedState], [null,true])) + "><div class=\"hero-avatar\"><img" + (jade.attr("src", view.getPortraitURL(hero), true, true)) + "></div><div class=\"text-h5 hero-name\"><span>" + (jade.escape(null == (jade_interp = view.getHeroShortName(hero)) ? "" : jade_interp)) + "</span></div></div>");
};
buf.push("<div class=\"hero-list\">");
if ( view.heroes)
{
// iterate view.heroes
;(function(){
  var $$obj = view.heroes;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var hero = $$obj[$index];

if ( hero.heroClass === 'Warrior')
{
jade_mixins["heroOption"](hero);
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var hero = $$obj[$index];

if ( hero.heroClass === 'Warrior')
{
jade_mixins["heroOption"](hero);
}
    }

  }
}).call(this);

}
buf.push("</div>");}.call(this,"state" in locals_for_with?locals_for_with.state:typeof state!=="undefined"?state:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/hero-select-view.jade
// module id = 843
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91